import { render, staticRenderFns } from "./customFilterJGT.vue?vue&type=template&id=0a9add06&scoped=true&"
import script from "./customFilterJGT.vue?vue&type=script&lang=js&"
export * from "./customFilterJGT.vue?vue&type=script&lang=js&"
import style0 from "./customFilterJGT.vue?vue&type=style&index=0&id=0a9add06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9add06",
  null
  
)

export default component.exports